class FeatureRound {
    _started = false;
    _totalWin = 0;

    start() {
        this._totalWin = 0;
        this._started = true;
    }

    stop() {
        this._started = false;
        this._totalWin = 0;
    }

    isStarted() {
        return this._started;
    }

    getTotalWin() {
        return this._totalWin;
    }

    addTotalWin(value) {
        this._totalWin += value;
    }
}

export default new FeatureRound();